import React from 'react';

import { Box, Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

import type { MegaNavSection } from '../../types';
import { MobileMenuSectionHeader } from './MobileMenuSectionHeader';

interface MobileSubMenuSectionProps {
  section: MegaNavSection;
  parentName: string;
}

export const MobileSubMenuSection: React.FC<MobileSubMenuSectionProps> = ({
  section,
  parentName,
}) => {
  return (
    <Col>
      <MobileMenuSectionHeader label={section.title} />
      <Col>
        {section.links.map((link, linkIdx) => (
          <Text
            as="li"
            key={linkIdx}
            className={cn(
              'border-od-border-primary',
              linkIdx < section.links.length - 1 && 'border-b',
            )}
          >
            <Box
              href={link.href}
              aria-label={`Navigate to ${link.name}`}
              analyticsName={`cosmos-mega-nav-mobile-${parentName.toLowerCase()}-${link.name
                .toLowerCase()
                .replace(/\s+/g, '-')}`}
              className="py-4 pl-6 pr-4 no-underline"
            >
              <Text as="span" className="text-body-md text-od-content-primary">
                {link.name}
              </Text>
            </Box>
          </Text>
        ))}
      </Col>
    </Col>
  );
};
